import { ActivityStatus } from "@cca/components";
import { CourseItemType } from "@core/enums";
import { LearningModuleItemDto } from "@core/types";
import { ActivityDto, CourseItemDto } from "@core/typesV2";

export function isActivityWithProgress(
  activity: ActivityDto,
): activity is ActivityDto {
  return Boolean(activity.progress);
}

export type DayPathResult = {
  unit?: LearningModuleItemDto;
  topic?: LearningModuleItemDto;
  day?: LearningModuleItemDto;
};
type IndexedItem = {
  item: CourseItemDto;
  index: string;
};
export function findDayPath(
  items: CourseItemDto[],
  dayId: string,
  parents: CourseItemDto[] = [],
  rootItems: CourseItemDto[] | null = null,
): DayPathResult | null {
  if (rootItems === null) {
    rootItems = items;
  }
  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (item.id === dayId) {
      const result: IndexedItem[] = [];

      const findPosition = (arr: CourseItemDto[], id: string) =>
        arr.findIndex((el) => el.id === id) + 1;

      for (let j = 0; j < parents.length; j++) {
        const parent = parents[j];
        let position: number;

        if (j === 0) {
          position = findPosition(rootItems, parent.id);
        } else {
          position = findPosition(parents[j - 1].items, parent.id);
        }

        result.push({ item: parent, index: `${position}` });
      }

      const dayPosition =
        parents.length > 0
          ? findPosition(parents[parents.length - 1].items, dayId)
          : findPosition(rootItems, dayId);

      const output: DayPathResult = {
        day: { displayNumber: dayPosition, name: item.name },
      };

      result.forEach(({ item: parent, index }) => {
        const num = parseInt(index);
        if (parent.type === CourseItemType.Unit) {
          output.unit = { displayNumber: num, name: parent.name };
        } else if (parent.type === CourseItemType.Topic) {
          output.topic = { displayNumber: num, name: parent.name };
        }
      });

      return output;
    }

    if (item.items.length > 0) {
      const found = findDayPath(
        item.items,
        dayId,
        [...parents, item],
        rootItems,
      );
      if (found) return found;
    }
  }

  return null;
}

export const areActivitiesWithProgress = (activities: ActivityDto[]): boolean =>
  activities.every((activity) => activity.progress != null);

export const areActivitiesNotStarted = (activities: ActivityDto[]): boolean =>
  activities.every(
    (activity) => activity.progress?.status === ActivityStatus.NotStarted,
  );
